import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { useRouter } from "next/router"
import colors from "@constants/colors"
import { bodyBold } from "@constants/typography"
import MaxWidthContainer from "@components/Layout/MaxWidthContainer"
import MaxWidthContent from "@components/Layout/MaxWidthContent"

const Container = styled.div`
  align-items: center;
  display: flex;
`

const Text = styled.div`
  ${bodyBold}
  margin-right: 6px;
  color: ${colors.slateDark};
`

const LinkText = styled(Text)`
  text-decoration: underline;

  ${up("laptop")} {
    &:hover {
      cursor: pointer;
    }
  }
`

interface EmptyProps {}

const Empty: React.FC<EmptyProps> = () => {
  const router = useRouter()

  return (
    <MaxWidthContainer noMobilePadding>
      <MaxWidthContent cols={12}>
        <Container>
          <Text>No products found.</Text>
          <LinkText
            onClick={() => {
              router.back()
            }}
          >
            Go Back
          </LinkText>
        </Container>
      </MaxWidthContent>
    </MaxWidthContainer>
  )
}

export default Empty
